// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FH5pH1x8ykuBpW {
  display: flex;
  justify-content: flex-start;
}
.T1sA81V51wNPvT {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-100, 8px);
  padding: var(--ds-space-050, 4px) var(--ds-space-100, 8px);
}
.vQ9xbYnSUuZCQr {
  display: flex;
  align-items: center;
  gap: var(--ds-space-100, 8px);
}
.vQ9xbYnSUuZCQr::before,
.vQ9xbYnSUuZCQr::after {
  content: '';
  display: block;
  border-radius: var(--ds-border-radius-100, 4px);
  background-color: var(--ds-skeleton, #091e420f);
}
.vQ9xbYnSUuZCQr::before {
  width: 40px;
  height: 32px;
}
.vQ9xbYnSUuZCQr::after {
  width: 100%;
  height: 16px;
}
.QibdljFUklHPEK {
  flex: 0 0 calc(25% - 8px);
  min-width: 120px;
  height: 128px;
  margin: var(--ds-space-050, 4px);
  border-radius: var(--ds-border-radius-200, 8px);
  background-color: var(--ds-skeleton, #091e420f);
}
@media only screen and (max-width: 600px) {
  .QibdljFUklHPEK {
    flex-basis: calc(33.3% - 8px);
  }
}
@media only screen and (max-width: 450px) {
  .QibdljFUklHPEK {
    flex-basis: calc(50% - 8px);
  }
}
`, ""]);
// Exports
export var gridTilesWrapper = `FH5pH1x8ykuBpW`;
export var listTilesWrapper = `T1sA81V51wNPvT`;
export var listItem = `vQ9xbYnSUuZCQr`;
export var gridItem = `QibdljFUklHPEK`;
export default ___CSS_LOADER_EXPORT___;
